import React, { useState } from "react";
import GradingDetails from "../components/Programs/GradingDetails";
import Aside from "../modules/SideNav/Aside";

function GradingDetailsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            /> */}
      <GradingDetails handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default GradingDetailsLayout;
